import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c1b04fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container scrolled" }
const _hoisted_2 = { class: "list-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Especialidades", -1))
const _hoisted_4 = { class: "list-header" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "item-data" }
const _hoisted_7 = { class: "item-operations" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_field = _resolveComponent("text-field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Form, null, {
          default: _withCtx(() => [
            _createVNode(_component_text_field, {
              modelValue: _ctx.body.description,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.body.description) = $event)),
              name: 'description',
              label: 'Nome da especialidade',
              validators: { required: {} },
              onUpdateValidation: _ctx.updateValidation,
              validation: _ctx.validations.description
            }, null, 8, ["modelValue", "onUpdateValidation", "validation"])
          ]),
          _: 1
        }),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save())),
          class: _normalizeClass({
            btn: true,
            'btn-update': !_ctx.disableButton && _ctx.isFormValid && !!_ctx.specialty_id,
            'btn-new': !_ctx.disableButton && _ctx.isFormValid && !!!_ctx.specialty_id,
          }),
          disabled: !_ctx.isFormValid || _ctx.disableButton
        }, [
          (!!_ctx.specialty_id)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: ['fa', 'save']
              }))
            : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 1,
                icon: ['fa', 'plus']
              }))
        ], 10, _hoisted_5)
      ]),
      _createElementVNode("ul", {
        class: _normalizeClass({
          'list-items': true,
          loading: _ctx.isLoading,
          'empty-list': !_ctx.isLoading && !_ctx.specialties.length,
        })
      }, [
        (!_ctx.isLoading)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.specialties, (specialty) => {
              return (_openBlock(), _createElementBlock("li", {
                key: specialty.id
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("strong", null, _toDisplayString(specialty.description), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "btn btn-update",
                    onClick: ($event: any) => (_ctx.setToUpdate(specialty.id, specialty.description))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fa', 'pen-square'] })
                  ], 8, _hoisted_8),
                  _createElementVNode("button", {
                    class: "btn btn-delete",
                    onClick: ($event: any) => (_ctx.deleteSpecialty(specialty.id))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fa', 'trash'] })
                  ], 8, _hoisted_9)
                ])
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}